module.exports = __webpack_public_path__ + "static/media/beach-resort.d527a13c.png";